import { createPopoverPlugin } from '../../../plugins/popover'

export function createAreaPopoverPlugin (vm) {
  let showInputError = false
  let popoverReferenceIOInstance = null
  // 实例化气泡插件 并挂载在组件上
  const createPopoverPluginInstance = () => {
    if (!vm.popoverPluginInstance) {
      vm.popoverPluginInstance = createPopoverPlugin()
      vm.popoverPluginInstance.getPopperModalInstance({
        wrapClass: 'kye-area-plugin-popper',
      })
    }
  }
  // 移除气泡
  const hiddenPopover = () => {
    if (vm.popoverPluginInstance) {
      vm.popoverPluginInstance.hiddenPopover()
    }
  }

  const asyncHiddenPopover = () => {
    if (vm.popoverPluginInstance) {
      vm.popoverPluginInstance.asyncHiddenPopover()
    }
  }

  const removePopperHandleEvent = () => {
    if (vm.popoverPluginInstance) {
      vm.popoverPluginInstance.removePopperHandleEvent()
    }
  }

  const destroyPopver = () => {
    if (vm.popoverPluginInstance) {
      hiddenPopover()
      vm.popoverPluginInstance.destroyPopver()
      vm.popoverPluginInstance = null
    }
  }
  const destroyPopoverReferenceObserver = () => {
    if (popoverReferenceIOInstance) {
      popoverReferenceIOInstance.disconnect()
      popoverReferenceIOInstance = null
    }
  }

  const visiblePoppver = () => {
    createPopoverPluginInstance()
     // 进入时。设置为true.更新位置
     if (showInputError) {
        if (vm.popoverPluginInstance) {
          vm.popoverPluginInstance.getPopperModalInstance().value = true
          vm.$nextTick(() => {
            vm.popoverPluginInstance.updatePopper()
          })
        }
      }
  }

  // 开启监听气泡参照物的是否出现在可视区域
  const popoverReferenceObserver = () => {
    // 要观察的元素
    const targetElement = vm.$el
    // 有错误的元素证明一定要显示
    if (!targetElement) {
      return
    }
    destroyPopoverReferenceObserver()
    popoverReferenceIOInstance = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 元素在可视区域内内
          visiblePoppver()
        } else {
          asyncHiddenPopover()
        }
      })
    }, {
      threshold: 0, // 可视区域的阈值，0表示只要有一点进入可视区域则会 entry.isIntersecting等于true反之false 1表示整体显示在可视区域
    }) // 设置交叉阈值为 50%
    // 开始观察
    popoverReferenceIOInstance.observe(targetElement)
  }

  // 生命周期中监听相关事件
  const lifeCycleHooks = () => {
    vm.$on('hook:mounted', () => {
      createPopoverPluginInstance()
      popoverReferenceObserver()
    })
    // 销毁相关事件
    vm.$on('hook:beforeDestroy', () => {
      destroyPopver()
      removePopperHandleEvent()
      destroyPopoverReferenceObserver()
    })
    vm.$on('hook:destroyed', () => {
      destroyPopver()
      removePopperHandleEvent()
      destroyPopoverReferenceObserver()
    })
    vm.$on('hook:activated', () => {
      visiblePoppver()
    })
    vm.$on('hook:deactivated', () => {
      // 组件离开钩子，设置为false
      hiddenPopover()
    })
  }
  lifeCycleHooks()

  const setShowInputErrorStatus = (val) => {
    vm.showInputError = val
  }
  const validate = (isCheckPass, content, reference, popoverAttrs) => {
    if (!isCheckPass) {
      const {
        popperWidth = 'auto',
        visibleArrow = true,
        placement = 'bottom-start',
        effect = 'dark'
      } = popoverAttrs || {}
      const poppverMergeOptions = {
        width: popperWidth,
        visibleArrow,
        content,
        placement,
        arrowOffset: -1000, // 超出就会在最左侧
        effect,
      }
      const _reference = reference || vm.$el
      content && vm.popoverPluginInstance.showPoppver(_reference, poppverMergeOptions, 'click')
    } else {
      vm.popoverPluginInstance.asyncHiddenPopover()
    }
    showInputError = !isCheckPass
    setShowInputErrorStatus(showInputError)
    return isCheckPass
  }
  const clearValidate = () => {
    hiddenPopover()
    setShowInputErrorStatus(false)
  }
  return {
    validate,
    clearValidate,
    showInputError,
    setShowInputErrorStatus
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/plugins/popover.js